type params = {
  rating: number | null;
  label: string;
  highlight?: boolean;
};

function formatNumber(num: number) {
  return num % 1 === 0 ? num : num.toFixed(1);
}

export default function RatingDisplay({ rating, label, highlight = false }: params) {
  const ratingLabel = !!rating ? `⭐️ ${formatNumber(rating)}` : "⭐️";
  const textColor = highlight ? "text-amber-700" : "text-slate-700";
  return (
    <div className="flex flex-col items-center">
      <span className={`font-bold text-2xl ${textColor}`}>
        {highlight ? `🗳️ ${formatNumber(rating)}` : ratingLabel}
      </span>
      <span className={`font-bold text-xs ${textColor}`}>{label}</span>
    </div>
  );
}
